/**
 * `server/internal/cash/handler_screening.go` declares `cash.screening.manage` on
 * every screening-list route — list, create, import and update alike. Reading the
 * list is therefore a compliance act too, not an operational one.
 *
 * (`cash.screening.clear` is the other screening permission; it clears a held
 * transfer instruction and lives on the instruction screen.)
 */

export const SCREENING_PERMISSIONS = {
  manage: 'cash.screening.manage',
} as const
